"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketGetDTO = exports.TicketDto = exports.UpdateTicketDto = exports.CreateTicketDocumentDto = exports.CreateTicketMessageDto = exports.CreateTicketDto = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const enums_1 = require("../enums");
const models_1 = require("../../../models");
class CreateTicketDto {
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CreateTicketDto.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.TicketRequestType),
    __metadata("design:type", String)
], CreateTicketDto.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateTicketDto.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateTicketDto.prototype, "assignedSalesAgentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateTicketDto.prototype, "agentName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateTicketDto.prototype, "agentPhoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], CreateTicketDto.prototype, "initialDocument", void 0);
exports.CreateTicketDto = CreateTicketDto;
class CreateTicketMessageDto {
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CreateTicketMessageDto.prototype, "ticketId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CreateTicketMessageDto.prototype, "senderId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateTicketMessageDto.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], CreateTicketMessageDto.prototype, "isFromAgent", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], CreateTicketMessageDto.prototype, "attachedDocument", void 0);
exports.CreateTicketMessageDto = CreateTicketMessageDto;
class CreateTicketDocumentDto {
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CreateTicketDocumentDto.prototype, "ticketId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], CreateTicketDocumentDto.prototype, "uploaderId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateTicketDocumentDto.prototype, "messageId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], CreateTicketDocumentDto.prototype, "document", void 0);
exports.CreateTicketDocumentDto = CreateTicketDocumentDto;
class UpdateTicketDto {
}
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.TicketRequestType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTicketDto.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTicketDto.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTicketDto.prototype, "assignedSalesAgentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTicketDto.prototype, "agentName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTicketDto.prototype, "agentPhoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.TicketStatusType),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateTicketDto.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], UpdateTicketDto.prototype, "documents", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => models_1.TicketMessage),
    __metadata("design:type", Array)
], UpdateTicketDto.prototype, "messages", void 0);
exports.UpdateTicketDto = UpdateTicketDto;
class TicketDto {
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], TicketDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], TicketDto.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.TicketRequestType),
    __metadata("design:type", String)
], TicketDto.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TicketDto.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TicketDto.prototype, "assignedSalesAgentId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], TicketDto.prototype, "assignedSalesAgent", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], TicketDto.prototype, "user", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TicketDto.prototype, "agentName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TicketDto.prototype, "agentPhoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.TicketStatusType),
    __metadata("design:type", String)
], TicketDto.prototype, "status", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], TicketDto.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], TicketDto.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => models_1.TicketMessage),
    __metadata("design:type", Array)
], TicketDto.prototype, "messages", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => models_1.TicketDocument),
    __metadata("design:type", Array)
], TicketDto.prototype, "documents", void 0);
exports.TicketDto = TicketDto;
class TicketGetDTO {
    constructor() {
        this.id = "";
        this.refId = 0;
        this.createdById = null;
        this.updatedById = null;
        this.deletedById = null;
        this.isDeleted = false;
        this.isActive = true;
        this.createdAt = new Date().toISOString();
        this.updatedAt = new Date().toISOString();
        this.userId = "";
        this.requestType = enums_1.TicketRequestType.CAR_VIEWING;
        this.message = "";
        this.assignedSalesAgentId;
        this.agentName = "";
        this.agentPhoneNumber = "";
        this.status = enums_1.TicketStatusType.OPEN;
    }
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TicketGetDTO.prototype, "refId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], TicketGetDTO.prototype, "createdById", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], TicketGetDTO.prototype, "updatedById", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], TicketGetDTO.prototype, "deletedById", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TicketGetDTO.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TicketGetDTO.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.TicketRequestType),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "assignedSalesAgentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "agentName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "agentPhoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.TicketStatusType),
    __metadata("design:type", String)
], TicketGetDTO.prototype, "status", void 0);
exports.TicketGetDTO = TicketGetDTO;
